import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/core/services/api.service';
import { Observable } from 'rxjs';
import {
  BatchUpdateDocumentDto,
  CreateDocumentVersionDto,
  CreateDocumentDto,
  DocumentVersionDto,
  GetDocumentDto,
  GetDocumentVersionDto,
} from '../models/documents.model';
import { environment } from 'src/environment/environment';

@Injectable({
  providedIn: 'root',
})
export class DocumentsApiService extends ApiService {
  getDocuments$(): Observable<GetDocumentDto[]> {
    return this.get<GetDocumentDto[]>('/documents');
  }
  createDocument$(document: CreateDocumentDto): Observable<GetDocumentDto> {
    return this.post('/documents', document);
  }

  batchUpdateDocuments$(documents: BatchUpdateDocumentDto[]): Observable<GetDocumentDto[]> {
    return this.post(`/documents/batch-update`, documents);
  }

  getDocumentById$(uniqId: string): Observable<GetDocumentDto> {
    return this.get(`/documents/${uniqId}`);
  }

  getDocumentVersions$(uniqId: string): Observable<DocumentVersionDto[]> {
    return this.get(`/documents/${uniqId}/versions`);
  }

  getDocumentVersion$(uniqId: string, versionNumber: number): Observable<GetDocumentVersionDto> {
    return this.get(`/documents/${uniqId}/versions/${versionNumber}`);
  }

  createDocumentVersion$(
    uniqId: string,
    model: CreateDocumentVersionDto,
  ): Observable<GetDocumentVersionDto> {
    return this.post(`/documents/${uniqId}/versions`, model);
  }

  deleteDocumentVersion$(uniqId: string, versionNumber: number): Observable<any> {
    return this.delete(`/documents/${uniqId}/versions/${versionNumber}`);
  }

  downloadDocumentById$(uniqId: string): Observable<any> {
    return this.getBlob(`/documents/download/${uniqId}`);
  }

  deleteDocument$(uniqueId: string): Observable<any> {
    return this.delete(`/documents/${uniqueId}`);
  }

  batchDeleteDocument$(uniqueIds: string[]): Observable<any> {
    return this.post(`/documents/batch-delete`, uniqueIds);
  }
}

export const apiDocumentsProtectedResources = [
  {
    httpMethod: 'GET',
    scopes: [...environment.protectedResources.apiDocuments.scopes.read],
  },
  {
    httpMethod: 'POST',
    scopes: [...environment.protectedResources.apiDocuments.scopes.write],
  },
  {
    httpMethod: 'PUT',
    scopes: [...environment.protectedResources.apiDocuments.scopes.write],
  },
  {
    httpMethod: 'DELETE',
    scopes: [...environment.protectedResources.apiDocuments.scopes.write],
  },
];
